import { Button, CloseButton } from '@ui/shared/Button';
import { User } from 'firebase/auth';
import * as React from 'react';
import { currentUser } from '../../../data/providers/userProvider';
import { CardBody } from '../../shared/card/CardBody';
import {
  CardFooter,
  CardFooterLeft,
  CardFooterRight,
} from '../../shared/card/CardFooter';
import {
  CardHeader,
  CardHeaderLeft,
  CardHeaderRight,
} from '../../shared/card/CardHeader';
import { FormContainer } from '../../shared/form/FormContainer';
import { LinearLoading } from '../../shared/loading/LinearLoading';
import { PopupCard, PopupCardContent } from '../../shared/popups/PopupCard';
import { Email } from './Email';
import { MultiFactor } from './MultiFactor';

interface IProps {
  onClose: () => void;
}

export const AccountSettingsPopup = (props: IProps): React.ReactElement => {
  const [user, setUser] = React.useState<User>();

  const [loading, setLoading] = React.useState<boolean>(false);

  /**
   * @description get the current user
   */
  React.useEffect((): void => {
    const mUser = currentUser();
    setUser(mUser);
  }, []);

  return (
    <PopupCard onClose={props.onClose} noClickOutside size='large'>
      <PopupCardContent>
        <CardHeader surface={8}>
          <CardHeaderLeft>
            <h5>Account Settings</h5>
          </CardHeaderLeft>
          <CardHeaderRight>
            <CloseButton onClick={props.onClose} />
          </CardHeaderRight>
        </CardHeader>
        <CardBody>
          {loading && <LinearLoading />}
          <FormContainer>
            <Email user={user} />
            <MultiFactor user={user} />
          </FormContainer>
        </CardBody>
        <CardFooter surface={8}>
          <CardFooterLeft />
          <CardFooterRight />
        </CardFooter>
      </PopupCardContent>
    </PopupCard>
  );
};
